import { render } from "./MyAccordion.vue?vue&type=template&id=7c5baa1a"
import script from "./MyAccordion.vue?vue&type=script&lang=js"
export * from "./MyAccordion.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__